<template>
  <router-view :formData.sync="formData"></router-view>
</template>

<script>
export default {
  data () {
    return {
      formData: {
        kiyk_nm: '',
        ybn_no: '',
        address: '',
        phone_no: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/KiykskMstr/KiykskMstrSnkTurkPrnt.vue